import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Container, Link } from '@olxbr/ds-web'
import { System } from '@olxbr/olx-icons'

const IconFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: var(--spacing-2);
  background-color: ${({ done }) =>
    done ? 'var(--color-feedback-success-80)' : 'var(--color-neutral-80)'};
  width: 32px;
  height: 32px;
  border-radius: 50%;
`

const CheckFlex = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: 0;
`

const LinkWithFlex = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`

export const StepButton = ({ icon, title, titleDone, description, done, path, onClick }) => {
  const Icon = icon

  const container = (
    <Container flexDirection="row" alignItems="center">
      <IconFlex done={done}>
        <Icon
          color={done ? 'var(--color-feedback-success-90)' : 'var(--color-neutral-120)'}
          size="18"
        />
      </IconFlex>
      <div className="flex flex-1 flex-col">
        <span className="typo-caption font-semibold text-neutral-130">
          {done ? titleDone : title}
        </span>
        <span className="typo-caption font-regular text-neutral-120">{description}</span>
      </div>
      <CheckFlex>
        {done ? (
          <System.Check color="var(--color-feedback-success-90)" />
        ) : (
          <System.ChevronRight color="var(--color-neutral-120)" />
        )}
      </CheckFlex>
    </Container>
  )

  return done ? (
    <div className="flex flex-col items-stretch">{container}</div>
  ) : (
    <LinkWithFlex href={path} onClick={onClick}>
      {container}
    </LinkWithFlex>
  )
}

StepButton.propTypes = {
  icon: PropTypes.func,
  title: PropTypes.string,
  titleDone: PropTypes.string,
  description: PropTypes.string,
  done: PropTypes.bool,
  path: PropTypes.string,
  onClick: PropTypes.func,
}

StepButton.defaultProps = {}
